import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { db } from '../../firebase/firebase-config';
import { ProgressBar } from '../shared/ProgressBar';
import Swal from 'sweetalert2';

const CATEGORIAS_SUGERIDAS = ['Uñas', 'Cabello', 'Pestañas', 'Cejas', 'Maquillaje', 'Faciales', 'Masajes', 'Depilación', 'Micropigmentación', 'Otros'];

const servicioVacio = (categoria = '') => ({
    servicio: '',
    precio: '',
    precioMaximo: '',
    duracion: 30,
    capacidad: '1',
    descripcion: '',
    imagen: '',
    montoAnticipo: 0,
    porcentajeAnticipo: 0,
    orden: 0,
    pidaAnticipo: false,
    categoria,
});

// ── Formulario de servicio ────────────────────────────────────────────────────
const FormServicio = ({ servicio, onChange, onGuardar, onCancelar, manejaAnticipo, categorias }) => {
    const horas = Math.floor(servicio.duracion / 60);
    const mins = servicio.duracion % 60;
    const [precioVariable, setPrecioVariable] = React.useState(!!servicio.precioMaximo);

    const adjDur = (delta) => {
        const nueva = Math.max(5, Math.min(480, servicio.duracion + delta * 5));
        onChange({ ...servicio, duracion: nueva });
    };

    const handleHorasInput = (val) => {
        const h = Math.max(0, Math.min(8, parseInt(val) || 0));
        onChange({ ...servicio, duracion: Math.max(5, h * 60 + mins) });
    };

    const handleMinsInput = (val) => {
        const m = Math.max(0, Math.min(55, Math.round((parseInt(val) || 0) / 5) * 5));
        onChange({ ...servicio, duracion: Math.max(5, horas * 60 + m) });
    };

    const limiteAnticipo = parseInt(servicio.precioMaximo || servicio.precio) || 0;

    return (
        <div style={{ background: 'var(--pink-50)', border: '0.5px solid var(--border)', borderRadius: 12, padding: 16, marginTop: 8 }}>
            <div className="field-label" style={{ marginTop: 0 }}>Nombre del servicio</div>
            <input className="field-input" placeholder="Ej. Manicura con gel" value={servicio.servicio}
                onChange={e => onChange({ ...servicio, servicio: e.target.value })} autoFocus />

            {categorias.length > 0 && (
                <>
                    <div className="field-label">Categoría</div>
                    <select className="field-input" value={servicio.categoria}
                        onChange={e => onChange({ ...servicio, categoria: e.target.value })}>
                        <option value="">Sin categoría</option>
                        {categorias.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                </>
            )}

            <div className="field-label">Precio</div>
            <div className="price-wrap">
                <span className="price-symbol">$</span>
                <input className="field-input price-input" placeholder="0" type="tel" inputMode="numeric"
                    value={servicio.precio} onChange={e => onChange({ ...servicio, precio: e.target.value.replace(/\D/g, '') })} />
            </div>

            <div className="toggle-row" style={{ marginTop: 10 }}>
                <div>
                    <div className="toggle-label">¿El precio varía?</div>
                    <div className="toggle-sub">Ej: pelo corto $200, largo $350</div>
                </div>
                <div className={`toggle ${precioVariable ? 'on' : ''}`}
                    onClick={() => { setPrecioVariable(!precioVariable); if (precioVariable) onChange({ ...servicio, precioMaximo: '' }); }}>
                    <div className="toggle-thumb" />
                </div>
            </div>
            {precioVariable && (
                <>
                    <div className="field-label">Precio máximo</div>
                    <div className="price-wrap">
                        <span className="price-symbol">$</span>
                        <input className="field-input price-input" placeholder="0" type="tel" inputMode="numeric"
                            value={servicio.precioMaximo} onChange={e => onChange({ ...servicio, precioMaximo: e.target.value.replace(/\D/g, '') })} />
                    </div>
                    <p className="field-hint">Deja vacío si el precio es fijo</p>
                </>
            )}

            <div className="field-label">Duración</div>
            <div className="duration-row">
                <div className="duration-col">
                    <input type="number" min="0" max="8" value={horas} onChange={e => handleHorasInput(e.target.value)}
                        style={{ width: '100%', textAlign: 'center', border: '0.5px solid var(--border)', borderRadius: 10, fontSize: 24, fontWeight: 600, color: 'var(--pink-900)', padding: '10px 0', background: 'var(--pink-100)', outline: 'none', WebkitAppearance: 'none', MozAppearance: 'textfield' }} />
                    <div className="duration-label">horas</div>
                </div>
                <div style={{ color: 'var(--pink-200)', fontSize: 22, paddingTop: 4 }}>:</div>
                <div className="duration-col">
                    <input type="number" min="0" max="55" step="5" value={String(mins).padStart(2, '0')} onChange={e => handleMinsInput(e.target.value)}
                        style={{ width: '100%', textAlign: 'center', border: '0.5px solid var(--border)', borderRadius: 10, fontSize: 24, fontWeight: 600, color: 'var(--pink-900)', padding: '10px 0', background: 'var(--pink-100)', outline: 'none', WebkitAppearance: 'none', MozAppearance: 'textfield' }} />
                    <div className="duration-label">minutos</div>
                </div>
                <div className="duration-controls">
                    <button className="dur-btn" onClick={() => adjDur(1)}>+</button>
                    <button className="dur-btn" onClick={() => adjDur(-1)}>−</button>
                </div>
            </div>
            <p style={{ fontSize: 12, color: 'var(--pink-800)', marginTop: 4, textAlign: 'center' }}>Total: {servicio.duracion} minutos</p>

            {manejaAnticipo && (
                <>
                    <div className="toggle-row" style={{ marginTop: 10 }}>
                        <div>
                            <div className="toggle-label">Este servicio pide anticipo</div>
                            <div className="toggle-sub">La clienta paga antes de confirmar</div>
                        </div>
                        <div className={`toggle ${servicio.pidaAnticipo ? 'on' : ''}`}
                            onClick={() => onChange({ ...servicio, pidaAnticipo: !servicio.pidaAnticipo, montoAnticipo: 0 })}>
                            <div className="toggle-thumb" />
                        </div>
                    </div>
                    {servicio.pidaAnticipo && (
                        <>
                            <div className="field-label">Monto del anticipo</div>
                            <div className="price-wrap">
                                <span className="price-symbol">$</span>
                                <input className="field-input price-input" placeholder="0" type="tel" inputMode="numeric"
                                    value={servicio.montoAnticipo || ''}
                                    onChange={e => onChange({ ...servicio, montoAnticipo: parseInt(e.target.value.replace(/\D/g, '')) || 0 })} />
                            </div>
                            {limiteAnticipo > 0 && servicio.montoAnticipo >= limiteAnticipo && (
                                <p className="field-error">El anticipo debe ser menor al precio</p>
                            )}
                        </>
                    )}
                </>
            )}

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 16 }}>
                <button className="btn-outline" onClick={onCancelar}>Cancelar</button>
                <button className="btn-primary" style={{ marginTop: 0 }} onClick={onGuardar}>Guardar</button>
            </div>
        </div>
    );
};

// ── Pantalla principal ────────────────────────────────────────────────────────
export const PasoServicios = ({ siguiente, anterior, manejaAnticipo }) => {
    const { hashtag } = useSelector(state => state.auth);
    const [servicios, setServicios] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [mostrarCategorias, setMostrarCategorias] = useState(false);
    const [nuevaCategoria, setNuevaCategoria] = useState('');
    const [agregando, setAgregando] = useState(false);
    const [agregandoEnCategoria, setAgregandoEnCategoria] = useState(null);
    const [editando, setEditando] = useState(null);
    const [svcActual, setSvcActual] = useState(servicioVacio());
    const [cargando, setCargando] = useState(false);
    const [cargandoCatalogo, setCargandoCatalogo] = useState(true);

    // Cargar catálogo y clasificaciones existentes
    useEffect(() => {
        const cargar = async () => {
            try {
                const catSnap = await db.doc(`general/${hashtag}/servicios/catalogo`).get();
                if (catSnap.exists && catSnap.data().servicios) {
                    setServicios(catSnap.data().servicios);
                }
                const empSnap = await db.doc(`general/${hashtag}`).get();
                const clStr = empSnap.data()?.clasificaciones || '';
                if (clStr) {
                    const cats = clStr.split(';').map(p => p.split('/')[0]);
                    setCategorias(cats);
                }
            } catch (e) {
                console.log('Error cargando catálogo:', e);
            } finally {
                setCargandoCatalogo(false);
                setMostrarCategorias(true); // siempre mostrar categorías al inicio
            }
        };
        cargar();
    }, [hashtag]);

    const persistir = async (nuevosServicios, nuevasCategorias) => {
        const cats = nuevasCategorias ?? categorias;
        // Recalcular orden por categoría
        let orden = 1;
        const reordenados = [...nuevosServicios];
        cats.forEach(cat => {
            reordenados.filter(s => s.categoria === cat).forEach(s => { s.orden = orden++; });
        });
        // Sin categoría al final
        reordenados.filter(s => !s.categoria || !cats.includes(s.categoria)).forEach(s => { s.orden = orden++; });

        await db.doc(`general/${hashtag}/servicios/catalogo`).set({ servicios: reordenados });

        // Guardar clasificaciones en Firestore si hay categorías
        if (cats.length > 0) {
            let cadena = '';
            let numActual = 1;
            cats.forEach(cat => {
                const count = reordenados.filter(s => s.categoria === cat).length;
                if (count > 0) {
                    if (cadena) cadena += ';';
                    cadena += `${cat}/${numActual}-${numActual + count - 1}`;
                    numActual += count;
                }
            });
            // Sin categoría
            const sinCat = reordenados.filter(s => !s.categoria || !cats.includes(s.categoria)).length;
            if (sinCat > 0 && !cadena) {
                cadena = `General/1-${sinCat}`;
            }
            if (cadena) await db.doc(`general/${hashtag}`).update({ clasificaciones: cadena });
        }

        return reordenados;
    };

    const handleGuardar = async () => {
        if (!svcActual.servicio.trim()) { Swal.fire('Falta el nombre', 'Escribe el nombre del servicio.', 'warning'); return; }
        if (!svcActual.precio) { Swal.fire('Falta el precio', 'Agrega el precio del servicio.', 'warning'); return; }
        if (categorias.length > 0 && !svcActual.categoria) { Swal.fire('Falta la categoría', 'Selecciona a qué categoría pertenece este servicio para que tus clientas lo encuentren en WhatsApp.', 'warning'); return; }
        if (svcActual.pidaAnticipo && svcActual.montoAnticipo >= parseInt(svcActual.precioMaximo || svcActual.precio)) {
            Swal.fire('Anticipo inválido', 'El anticipo debe ser menor al precio.', 'warning'); return;
        }

        const svcFinal = {
            servicio: svcActual.servicio.trim(),
            precio: svcActual.precio,
            precioMaximo: svcActual.precioMaximo || '',
            duracion: String(svcActual.duracion),
            capacidad: '1',
            descripcion: '',
            imagen: '',
            montoAnticipo: svcActual.pidaAnticipo ? (svcActual.montoAnticipo || 0) : 0,
            porcentajeAnticipo: 0,
            orden: 0,
            categoria: svcActual.categoria || '',
        };

        let nuevos;
        if (editando !== null) {
            nuevos = [...servicios];
            nuevos[editando] = svcFinal;
        } else {
            nuevos = [...servicios, svcFinal];
        }

        const reordenados = await persistir(nuevos);
        setServicios(reordenados);
        setEditando(null);
        setSvcActual(servicioVacio());
        setAgregando(false);
        setAgregandoEnCategoria(null);

        // Sugerir clasificaciones si llegan a 11
        if (nuevos.length === 11 && categorias.length === 0) {
            setMostrarCategorias(true);
        }
    };

    const handleEliminar = async (idx) => {
        const nuevos = servicios.filter((_, i) => i !== idx);
        const reordenados = await persistir(nuevos);
        setServicios(reordenados);
    };

    const handleEditar = (idx) => {
        setEditando(idx);
        const s = servicios[idx];
        setSvcActual({ ...s, duracion: parseInt(s.duracion) || 30, pidaAnticipo: (s.montoAnticipo || 0) > 0 });
        setAgregando(true);
        setAgregandoEnCategoria(null);
    };

    const agregarCategoria = async (nombre) => {
        const trimmed = nombre.trim();
        if (!trimmed || categorias.includes(trimmed)) return;
        const nuevasCats = [...categorias, trimmed];
        setCategorias(nuevasCats);
        setNuevaCategoria('');
        if (servicios.length > 0) await persistir(servicios, nuevasCats);
    };

    const eliminarCategoria = async (cat) => {
        const nuevasCats = categorias.filter(c => c !== cat);
        // Quitar categoría de servicios que la tenían
        const nuevosServicios = servicios.map(s => s.categoria === cat ? { ...s, categoria: '' } : s);
        setCategorias(nuevasCats);
        const reordenados = await persistir(nuevosServicios, nuevasCats);
        setServicios(reordenados);
    };

    const handleContinuar = async () => {
        if (servicios.length === 0) { Swal.fire('Sin servicios', 'Agrega al menos un servicio.', 'warning'); return; }
        setCargando(true);
        try { siguiente(); } finally { setCargando(false); }
    };

    if (cargandoCatalogo) {
        return (
            <div className="app-container" style={{ alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ fontSize: 32 }}>💅</div>
                <p style={{ color: 'var(--pink-800)', marginTop: 12 }}>Cargando servicios...</p>
            </div>
        );
    }

    // Agrupar servicios por categoría para mostrar
    const grupos = categorias.length > 0
        ? [
            ...categorias.map(cat => ({ cat, items: servicios.filter(s => s.categoria === cat) })),
            { cat: null, items: servicios.filter(s => !s.categoria || !categorias.includes(s.categoria)) }
          ].filter(g => g.items.length > 0 || g.cat !== null)
        : [{ cat: null, items: servicios }];

    return (
        <div className="app-container">
            <div className="app-header">
                <h1>Tus servicios</h1>
                <p>Paso 3 de 4</p>
            </div>
            <ProgressBar paso={3} />

            <div className="screen-body">

                {/* Banner sugerencia de clasificaciones */}
                {servicios.length >= 11 && !mostrarCategorias && (
                    <div style={{ background: '#FFF3E0', border: '0.5px solid #FFB74D', borderRadius: 10, padding: 14, marginBottom: 12 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: '#E65100', marginBottom: 4 }}>
                            💡 ¿Muchos servicios? Organízalos en categorías
                        </div>
                        <div style={{ fontSize: 12, color: '#BF360C', marginBottom: 10, lineHeight: 1.6 }}>
                            Con {servicios.length} servicios, tus clientas tardarán en encontrar lo que buscan en WhatsApp. Las categorías agrupan tus servicios para que sean más fáciles de encontrar.
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                            <button onClick={() => setMostrarCategorias(true)}
                                style={{ padding: '9px', background: '#E65100', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                                Organizar en categorías
                            </button>
                            <button onClick={() => setMostrarCategorias(true)}
                                style={{ padding: '9px', background: 'none', color: '#E65100', border: '0.5px solid #E65100', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
                                Después
                            </button>
                        </div>
                    </div>
                )}

                {/* Sección de categorías */}
                {mostrarCategorias && (
                    <div style={{ background: 'var(--pink-50)', border: '0.5px solid var(--border)', borderRadius: 12, padding: 14, marginBottom: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--pink-900)' }}>
                                🏷️ ¿En qué categorías ofreces servicios?
                            </div>
                            {categorias.length === 0 && (
                                <button onClick={() => setMostrarCategorias(false)}
                                    style={{ fontSize: 11, color: 'var(--pink-800)', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}>
                                    Saltar
                                </button>
                            )}
                        </div>
                        <div style={{ fontSize: 12, color: 'var(--pink-800)', marginBottom: 10, lineHeight: 1.6 }}>
                            Ayudan a tus clientas a encontrar más rápido lo que buscan en WhatsApp. Puedes elegir varias.
                        </div>

                        {/* Categorías actuales */}
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
                            {categorias.map(cat => (
                                <div key={cat} style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '5px 10px', background: 'var(--pink-100)', border: '0.5px solid var(--pink-400)', borderRadius: 20 }}>
                                    <span style={{ fontSize: 13, color: 'var(--pink-900)', fontWeight: 500 }}>{cat}</span>
                                    <span style={{ fontSize: 11, color: 'var(--pink-800)' }}>({servicios.filter(s => s.categoria === cat).length})</span>
                                    <button onClick={() => eliminarCategoria(cat)}
                                        style={{ color: '#c62828', background: 'none', border: 'none', fontSize: 16, cursor: 'pointer', lineHeight: 1, padding: '0 2px' }}>×</button>
                                </div>
                            ))}
                        </div>

                        {/* Sugerencias */}
                        {categorias.length < 10 && (
                            <>
                                <div style={{ fontSize: 12, color: 'var(--pink-800)', marginBottom: 6 }}>Sugerencias:</div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
                                    {CATEGORIAS_SUGERIDAS.filter(c => !categorias.includes(c)).map(c => (
                                        <button key={c} onClick={() => agregarCategoria(c)}
                                            style={{ padding: '5px 10px', background: '#fff', border: '0.5px solid var(--border)', borderRadius: 20, fontSize: 12, color: 'var(--pink-800)', cursor: 'pointer' }}>
                                            + {c}
                                        </button>
                                    ))}
                                </div>
                            </>
                        )}

                        {/* Nueva categoría personalizada */}
                        <div style={{ display: 'flex', gap: 8 }}>
                            <input className="field-input" style={{ flex: 1, fontSize: 13, padding: '8px 12px' }}
                                placeholder="Nueva categoría..." value={nuevaCategoria}
                                onChange={e => setNuevaCategoria(e.target.value)}
                                onKeyDown={e => e.key === 'Enter' && agregarCategoria(nuevaCategoria)} />
                            <button onClick={() => agregarCategoria(nuevaCategoria)}
                                style={{ padding: '8px 14px', background: 'var(--pink-600)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                + Agregar
                            </button>
                        </div>
                    </div>
                )}

                {/* Lista de servicios agrupados */}
                {grupos.map((grupo, gi) => (
                    <div key={gi} style={{ marginBottom: 8 }}>
                        {grupo.cat && (
                            <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--pink-900)', textTransform: 'uppercase', letterSpacing: 0.5, padding: '6px 0 4px', borderBottom: '0.5px solid var(--border)', marginBottom: 4 }}>
                                {grupo.cat} <span style={{ fontWeight: 400, color: 'var(--pink-800)', textTransform: 'none' }}>({grupo.items.length})</span>
                            </div>
                        )}

                        {grupo.items.map((s, idx) => {
                            const idxReal = servicios.indexOf(s);
                            return (
                                <div key={idx} className="item-card" style={{ marginLeft: grupo.cat ? 8 : 0 }}>
                                    <div className="item-icon">💅</div>
                                    <div style={{ flex: 1 }}>
                                        <div className="item-name">{s.servicio}</div>
                                        <div className="item-meta">
                                            ${s.precio}{s.precioMaximo ? `–$${s.precioMaximo}` : ''} · {s.duracion} min
                                            {s.montoAnticipo > 0 ? ` · Anticipo $${s.montoAnticipo}` : ''}
                                        </div>
                                    </div>
                                    <button onClick={() => handleEditar(idxReal)}
                                        style={{ color: 'var(--pink-600)', background: 'none', border: 'none', fontSize: 16, cursor: 'pointer', padding: '4px 6px' }}>✎</button>
                                    <button onClick={() => handleEliminar(idxReal)}
                                        style={{ color: '#c62828', background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', padding: '4px 4px' }}>×</button>
                                </div>
                            );
                        })}

                        {/* Botón + dentro de la categoría */}
                        {grupo.cat && (
                            agregandoEnCategoria === grupo.cat && editando === null ? (
                                <FormServicio
                                    servicio={svcActual}
                                    onChange={setSvcActual}
                                    onGuardar={handleGuardar}
                                    onCancelar={() => { setAgregandoEnCategoria(null); setSvcActual(servicioVacio()); }}
                                    manejaAnticipo={manejaAnticipo}
                                    categorias={categorias}
                                />
                            ) : (
                                <button className="add-btn" style={{ marginLeft: 8, fontSize: 12, padding: '7px' }}
                                    onClick={() => {
                                        setSvcActual(servicioVacio(grupo.cat));
                                        setAgregandoEnCategoria(grupo.cat);
                                        setAgregando(false);
                                        setEditando(null);
                                    }}>
                                    + Agregar en {grupo.cat}
                                </button>
                            )
                        )}
                    </div>
                ))}

                {/* Formulario de edición */}
                {editando !== null && (
                    <FormServicio
                        servicio={svcActual}
                        onChange={setSvcActual}
                        onGuardar={handleGuardar}
                        onCancelar={() => { setAgregando(false); setEditando(null); setSvcActual(servicioVacio()); }}
                        manejaAnticipo={manejaAnticipo}
                        categorias={categorias}
                    />
                )}

                {/* Formulario nuevo servicio general */}
                {agregando && editando === null && agregandoEnCategoria === null ? (
                    <FormServicio
                        servicio={svcActual}
                        onChange={setSvcActual}
                        onGuardar={handleGuardar}
                        onCancelar={() => { setAgregando(false); setSvcActual(servicioVacio()); }}
                        manejaAnticipo={manejaAnticipo}
                        categorias={categorias}
                    />
                ) : editando === null && agregandoEnCategoria === null && (
                    <button className="add-btn" onClick={() => { setSvcActual(servicioVacio()); setAgregando(true); }}>
                        + Agregar servicio
                    </button>
                )}

                {servicios.length >= 11 && !mostrarCategorias && (
                    <button onClick={() => setMostrarCategorias(true)}
                        style={{ width: '100%', padding: '10px', background: 'none', color: 'var(--pink-600)', border: '0.5px solid var(--pink-200)', borderRadius: 10, fontSize: 13, cursor: 'pointer', marginTop: 8 }}>
                        🏷️ Organizar en categorías
                    </button>
                )}
            </div>

            <div className="screen-footer">
                <button className="btn-primary" onClick={handleContinuar} disabled={cargando}>
                    {cargando ? 'Guardando...' : 'Continuar'}
                </button>
                <button className="btn-secondary" onClick={anterior}>Volver</button>
            </div>
        </div>
    );
};
